import React from "react";
import { Helmet } from "react-helmet";

const GroupData = () => {
  return (
    <>

      <Helmet>
        <title>Groupdata | Nandan Denim Ltd .</title>
      </Helmet>
    </>
  )
};

export default GroupData;
